import * as COMMON from '../constants/Common';

const initialState = {
    locale: '',
    sid: '',
    phoneNumberList: {},
    memberIdList: {},
};

export default (state = initialState, action) => {
    if (action.type === COMMON.SET_SID) {
        const { sid } = action.payload;
        return {
            ...state,
            sid,
        }
    } else if (action.type === COMMON.SET_LANG) {
        const { lang: locale } = action.payload
        if (locale) {
            return {
                ...state,
                locale,
            }
        }
    } else if (action.type === COMMON.SAVE_PHONE) {
        const { phone, sid } = action.payload;
        if (phone && sid) {
            return {
                ...state,
                phoneNumberList: {
                    ...state.phoneNumberList,
                    [sid]: phone,
                }
            }
        }
    } else if (action.type === COMMON.SAVE_MEMBER_ID) {
        const { memberId, sid } = action.payload;
        if (memberId && sid) {
            return {
                ...state,
                memberIdList: {
                    ...state.memberIdList,
                    [sid]: memberId,
                },
                sid,
            }
        }
    } else if (action.type === COMMON.LOGOUT) {
        const { sid } = action.payload;
        if (sid) {
            const temp = { ...state.memberIdList }
            delete temp[sid]
            return {
                ...state,
                memberIdList: { ...temp },
            }
        }
    }
    return state;
}